<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" xml:space="preserve">
    <g transform="translate(128 128) scale(0.72 0.72)">
      <g transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)">
        <path fill="white" d="M7.3,1.4C6.9,1.4,6.4,1.3,6,1C5.6,0.7,5.3,0.2,5.2-0.3c0-0.1,0-0.3,0-0.4H3.8v3.8l0,2.1c0,0.6-0.4,1-0.9,1.2    c-0.1,0-0.3,0.1-0.5,0.1C2.2,6.5,2,6.4,1.9,6.3C1.5,6.1,1.2,5.7,1.2,5.2C1.2,4.5,1.8,4,2.5,4C2.6,4,2.8,4,2.9,4V3V2.6    c-0.1,0-0.3,0-0.4,0c-0.8,0-1.5,0.3-2,0.9C0.1,3.9-0.1,4.5-0.2,5c0,0.8,0.2,1.5,0.8,2c0.1,0.1,0.2,0.2,0.3,0.2    c0.5,0.4,1,0.6,1.6,0.6c0.1,0,0.3,0,0.4,0C3.5,7.8,4,7.5,4.4,7.1c0.5-0.5,0.8-1.2,0.8-1.9l0-3.1C5.4,2.3,5.7,2.4,6,2.6    c0.4,0.2,0.9,0.3,1.4,0.3v-1L7.3,1.4C7.3,1.4,7.3,1.4,7.3,1.4L7.3,1.4z" />
      </g>
    </g>
  </svg>
</template>
